/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Folder_LabelInputs */



/**
* | output |
* | --- |
* | "Export Folder" |
*
* @param {Audio_Description_Export_Folder_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_folder_label = /** @type {((inputs?: Audio_Description_Export_Folder_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Folder_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dossier d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportordner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cartella di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт папки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carpeta de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートフォルダ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्सपोर्ट फ़ोल्डर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pasta de exportação")
	return /** @type {LocalizedString} */ ("Export Folder")
});